import { render, staticRenderFns } from "./ClubImgSlider.vue?vue&type=template&id=33bfe41f"
import script from "./ClubImgSlider.vue?vue&type=script&lang=js"
export * from "./ClubImgSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports